module.exports = __webpack_public_path__ + "static/media/countries.d27c1ad7.png";